<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
      >
        <!-- <el-form-item label="社区" prop="userName">
          <el-input
            v-model.trim="form.userName"
            placeholder="请输入用户名(长度32字符内)"
            maxlength="32"
            style="width: 90%"
          ></el-input>
        </el-form-item>-->
        <el-form-item label="社区" prop="wlCommunityId">
          <el-select v-model="form.wlCommunityId" placeholder="请选择活动区域">
            <el-option
              v-for="item in communityList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="点位" prop="pointPosition">
          <el-input
            v-model.trim="form.pointPosition"
            placeholder="请输入点位(长度10字符内)"
            maxlength="16"
            style="width: 90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度">
          <el-input v-model.trim="form.longitude" placeholder="请输入经度" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="纬度">
          <el-input v-model.trim="form.latitude" placeholder="请输入纬度" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage'
// import { listMixin } from '@/mixins/listMixin'

export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  data () {
    return {
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {},
      communityList: [],
      validatorRules: {
        wlCommunityId: [
          { required: true, message: '请输入社区', trigger: 'blur' },
        ],
        pointPosition: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 10, message: '长度在10 个字符以内', trigger: 'change' },
        ],
      },
      url: {
        getCommunity: '/wlCommunityDict/cleanCommunity',
        add: '/wlCleanPointPosition/save',
        // edit: 'user/updateUser',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    add () {
      this.edit({})
    },
    //TODO 编辑还没做
    edit (record) {
      this.form = Object.assign({}, record)

      this.visible = true
    },
    close () {
      this.$refs.form.resetFields()
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          const parms = this.form
          // const parms = {
          //   email: this.form.email,
          //   mobile: this.form.mobile,
          //   password: this.form.passWord,
          //   pointPosition: this.form.pointPosition,
          //   roleId: this.form.roleId,
          //   sex: this.form.sex,
          //   userName: this.form.userName,
          // }
          if (!this.form.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post' //put
            parms.userId = this.form.id
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success('操作成功')
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    async getCommunity () {
      let res = await httpAction(this.url.getCommunity, {}, 'get')
      console.log(res)
      if (res.code !== 200) return this.$message.warning(res.msg)
      this.communityList = res.data
    },
  },
  created () {
    this.getCommunity()
  },
  mounted () { },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
